import { render, staticRenderFns } from "./journalAdvance.vue?vue&type=template&id=d194b812&scoped=true&"
import script from "./journalAdvance.vue?vue&type=script&lang=js&"
export * from "./journalAdvance.vue?vue&type=script&lang=js&"
import style0 from "./journalAdvance.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./journalAdvance.vue?vue&type=style&index=1&id=d194b812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d194b812",
  null
  
)

export default component.exports